import { Routes } from '@angular/router';
import { FishingComponent } from './fishing/fishing.component';
import { MapsComponent } from './maps/maps.component';
import { TracksComponent } from './tracks/maps.component';
import { LoginComponent } from './login/login.component';
import { CatchesComponent } from './catches/catches.component';
import { CatchDetailComponent } from './catch-detail/catch-detail.component';
import { TripsComponent } from './trips/trips.component';
import { TripDetailComponent } from './trip-detail/trip-detail.component';
import { SettingsComponent } from './settings/settings.component';
import { FishTypesSettingsComponent } from './settings/fish-types/fish-types.component';
import { PromptSnippetsComponent } from './settings/prompt-snippets/prompt-snippets.component';
import { ProcessingGuideComponent } from './settings/processing/processing.component';
import { McpToolsComponent } from './settings/mcp-tools/mcp-tools.component';
import { McpSystemPromptComponent } from './settings/mcp-system-prompt/mcp-system-prompt.component';
import { FailedJobsComponent } from './settings/failed-jobs/failed-jobs.component';
import { JobDetailComponent } from './settings/job-detail/job-detail.component';
import { SpotsComponent } from './spots/spots.component';
import { SpotDetailComponent } from './spot-detail/spot-detail.component';
import { authGuard } from './auth.guard';

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'fishing', component: FishingComponent, canActivate: [authGuard] },
    { path: 'maps', component: MapsComponent, canActivate: [authGuard] },
    { path: 'tracks', component: TracksComponent, canActivate: [authGuard] },
    { path: 'catches', component: CatchesComponent, canActivate: [authGuard] },
    { path: 'catch/:id', component: CatchDetailComponent, canActivate: [authGuard] },
    { path: 'trips', component: TripsComponent, canActivate: [authGuard] },
    { path: 'trip/:id', component: TripDetailComponent, canActivate: [authGuard] },
    { path: 'settings', component: SettingsComponent, canActivate: [authGuard] },
    { path: 'settings/fish-types', component: FishTypesSettingsComponent, canActivate: [authGuard] },
    { path: 'settings/prompt-snippets', component: PromptSnippetsComponent, canActivate: [authGuard] },
    { path: 'settings/processing', component: ProcessingGuideComponent, canActivate: [authGuard] },
    { path: 'settings/mcp-tools', component: McpToolsComponent, canActivate: [authGuard] },
    { path: 'settings/mcp-system-prompt', component: McpSystemPromptComponent, canActivate: [authGuard] },
    { path: 'settings/jobs', component: FailedJobsComponent, canActivate: [authGuard] },
    { path: 'settings/jobs/:id', component: JobDetailComponent, canActivate: [authGuard] },
    { path: 'settings/failed-jobs', component: FailedJobsComponent, canActivate: [authGuard] },
    { path: 'spots', component: SpotsComponent, canActivate: [authGuard] },
    { path: 'spot/:id', component: SpotDetailComponent, canActivate: [authGuard] },
    { path: '', redirectTo: '/fishing', pathMatch: 'full' }
];
